import React from 'react';

import ActionsPlayNormalXsmall from '@strava/icons/ActionsPlayNormalXsmall';

import { useMRE } from '../../hooks/useMRE';
import { useMREState } from '../../hooks/useMREState';

import styles from './FlyoverStart.module.scss';

export const FlyoverStart = () => {
  const { terrainEngine, track, t } = useMRE();
  const {
    setShowPOIs,
    showPOIs,
    setIsFlyoverInProgress,
    showPOIsOnFlyoverCompleteRef
  } = useMREState();

  const handleStartFlyover = () => {
    if (terrainEngine) {
      // Set showPOIsOnFlyoverCompleteRef to the current showPOIs state
      // This will be used to restore the showPOIs state when the flyover completes
      showPOIsOnFlyoverCompleteRef &&
        (showPOIsOnFlyoverCompleteRef.current = showPOIs);

      // Hide POIs during flyover
      setShowPOIs(false);

      setIsFlyoverInProgress(true);

      track({
        action: 'screen_enter',
        element: 'flyover'
      });
    }
  };

  return (
    <button
      title={t('mre.flyover.start')}
      className={styles.flyoverStart}
      onClick={handleStartFlyover}
      data-testid="mre-start-flyover-button"
    >
      <ActionsPlayNormalXsmall />
    </button>
  );
};
